import { destroy, stopSubmit } from 'redux-form'
import {
  all,
  call,
  put,
  select,
  take,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'
import {
  IRequestUpdateRoom,
  IRoomWasDeleted,
  roomWasDeleted,
} from '../../actions/bookingCalendar/room/requestDeleteRoom'
import { callFetch } from '../../actions/fetch'
import closeModal from '../../actions/Modals/closeModal'
import fireToastError from '../../actions/toasts/fireToastError'
import { Modals } from '../../containers/Modals/ModalContainer'
import { database } from '../../database'
import i18n from '../../i18n'
import { deleteRoom as requestDelete } from '../../models/Room'
import { RoomActions } from '../../reducers/bookingCalendar/actionNames'
import { getRoomIdFromOpenModal } from '../../reducers/bookingCalendar/selectors/getModalOpen'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* deleteRoom(action: IRequestUpdateRoom) {
  try {
    const roomId = yield select(getRoomIdFromOpenModal)
    const actionNames = fetchActionsName(ActionNames.RemoveRoom)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, requestDelete)),
    ])

    yield call(service, roomId ? roomId : action.roomId)
    yield all([
      put(closeModal(Modals.EditRoom)),
      destroy('update_room'),
      put(roomWasDeleted(roomId ? roomId : action.roomId)),
    ])
  } catch (e) {
    yield stopSubmit('update_room', e)
    yield put(fireToastError(i18n.t('cannot_remove_room')))
  }
}

function* deleteRoomfromDb(action: IRoomWasDeleted) {
  yield database.rooms.delete(action.roomId.toString())
  yield database.events.where({ roomId: action.roomId.toString() }).delete()
}

export default function*() {
  yield takeLatest(RoomActions.RequestDeleteRoom, deleteRoom)
  yield takeEvery(RoomActions.RoomWasDeleted, deleteRoomfromDb)
}
